module.exports = __webpack_public_path__ + "static/media/send_white.e64e8205.svg";